import {
  actionTypes,
  fetchTaskSuccess,
  fetchTaskFailure,
  fetchTaskDetailSuccess,
  fetchTaskDetailFailure,
  approveTaskRequestSuccess,
  approveTaskRequestFailure,
  rejectTaskRequestSuccess,
  rejectTaskRequestFailure,
  approveCommentTaskRequestSuccess,
  approveCommentTaskRequestFailure,
  rejectCommentTaskRequestFailure,
  rejectCommentTaskRequestSuccess,
  takeChargeRequestSucess,
  takeChargeRequestFailure,
  cancelTakeChargeRequestSucess,
  cancelTakeChargeRequestFailure,
  fetchPaginatedTaskSuccess,
  fetchPaginatedTaskFailure,
  fetchCSVTaskFailure,
  fetchCSVTaskSuccess,
} from './actions'
import { ofType } from 'redux-observable'
import { mergeMap, map, catchError } from 'rxjs/operators'
import { of } from 'rxjs'
import {
  fetchTaskRequests,
  fetchTaskDetail,
  fetchTaskApprove,
  fetchTaskReject,
  fetchTaskApproveWithComment,
  fetchTaskRejectWithComment,
  fetchTakeCharge,
  fetchCancelTakeCharge,
  fetchPaginatedTaskRequests,
  fetchCSVTaskRequests,
} from './services'

const fetchTaskRequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_TASKS_REQUEST),
    mergeMap(() =>
      fetchTaskRequests().pipe(
        map((response) => fetchTaskSuccess(response)),
        catchError((error: any) => of(fetchTaskFailure(error)))
      )
    )
  )

const fetchCSVTaskRequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_CSV_TASKS_REQUEST),
    mergeMap((action: any) =>
      fetchCSVTaskRequests(action.payload).pipe(
        map((response) => fetchCSVTaskSuccess(response)),
        catchError((error: any) => of(fetchCSVTaskFailure(error)))
      )
    )
  )

const fetchPaginatedTaskRequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_PAGINATED_TASKS_REQUEST),
    mergeMap((action: any) =>
      fetchPaginatedTaskRequests(action.payload).pipe(
        map((response) => fetchPaginatedTaskSuccess(response)),
        catchError((error: any) => of(fetchPaginatedTaskFailure(error)))
      )
    )
  )

const fetchTaskDetailEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_TASK_DETAIL),
    mergeMap((action: any) =>
      fetchTaskDetail(action.body).pipe(
        map((response) => {
          return fetchTaskDetailSuccess(response)
        }),
        catchError((error: any) => {
          return of(fetchTaskDetailFailure(error))
        })
      )
    )
  )

const approveTaskRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.APPROVE_TASK_REQUEST),
    mergeMap((action: any) =>
      fetchTaskApprove(action.body).pipe(
        map((response) => {
          return approveTaskRequestSuccess(response)
        }),
        catchError((error: any) => {
          return of(approveTaskRequestFailure(error))
        })
      )
    )
  )

const approveCommentTaskRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.APPROVE_COMMENT_TASK_REQUEST),
    mergeMap((action: any) =>
      fetchTaskApproveWithComment(action.req.body, action.req.comment).pipe(
        map((response) => {
          return approveCommentTaskRequestSuccess(response)
        }),
        catchError((error: any) => {
          return of(approveCommentTaskRequestFailure(error))
        })
      )
    )
  )

const rejectTaskRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.REJECT_TASK_REQUEST),
    mergeMap((action: any) =>
      fetchTaskReject(action.body).pipe(
        map((response) => {
          return rejectTaskRequestSuccess(response)
        }),
        catchError((error: any) => {
          return of(rejectTaskRequestFailure(error))
        })
      )
    )
  )

const rejectCommentTaskRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.REJECT_COMMENT_TASK_REQUEST),
    mergeMap((action: any) =>
      fetchTaskRejectWithComment(action.req.body, action.req.comment).pipe(
        map((response) => {
          return rejectCommentTaskRequestSuccess(response)
        }),
        catchError((error: any) => {
          return of(rejectCommentTaskRequestFailure(error))
        })
      )
    )
  )

const takeChargeRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TAKE_CHARGE_TASK_REQUEST),
    mergeMap((action: any) =>
      fetchTakeCharge(action.payload).pipe(
        map((response) => {
          return takeChargeRequestSucess(response)
        }),
        catchError((error: any) => {
          return of(takeChargeRequestFailure(error))
        })
      )
    )
  )

const cancelTakeChargeRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CANCEL_TAKE_CHARGE_TASK_REQUEST_TASK_REQUEST),
    mergeMap((action: any) =>
      fetchCancelTakeCharge(action.payload).pipe(
        map((response) => {
          return cancelTakeChargeRequestSucess(response)
        }),
        catchError((error: any) => {
          return of(cancelTakeChargeRequestFailure(error))
        })
      )
    )
  )

const epics = [
  fetchCSVTaskRequestsEpic,
  fetchTaskRequestsEpic,
  fetchPaginatedTaskRequestsEpic,
  fetchTaskDetailEpic,
  approveTaskRequestEpic,
  rejectTaskRequestEpic,
  approveCommentTaskRequestEpic,
  rejectCommentTaskRequestEpic,
  cancelTakeChargeRequestEpic,
  takeChargeRequestEpic,
]

export default epics
